import { RotatingTriangles } from "react-loader-spinner";

interface Props {
  size?: number;
}

export default function Loader(props: Props) {
  return (
    <RotatingTriangles
      visible={true}
      height={props.size || 20}
      width={props.size || 20}
      colors={["var(--color-pink)", "var(--color-blue)", "var(--color-yellow)"]}
    />
  );
}
